function Bulgaria({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_802)">
  <path d="M32 16.0001C32 14.043 31.648 12.1682 31.0048 10.4349L16 9.73926L0.995188 10.4349C0.352063 12.1682 0 14.043 0 16.0001C0 17.9573 0.352063 19.8321 0.995188 21.5653L16 22.261L31.0048 21.5654C31.648 19.8321 32 17.9573 32 16.0001Z" fill="#496E2D"/>
  <path d="M16 32.0002C22.8795 32.0002 28.7442 27.6582 31.0049 21.5654H0.995239C3.25593 27.6582 9.12061 32.0002 16 32.0002Z" fill="#D80027"/>
  <path d="M0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0C9.12061 0 3.25593 4.342 0.995239 10.4348Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Bulgaria;
